export interface TypeVehicleMap {
  customurldownright: any;
  customurldownleft: any;
  customurlupright: any;
  customurlupleft: any;
  customurlright: any;
  customurlleft: any;
  customurldown: any;
  customurltop: any;
  customDirectionSvg: any;
  relentiDirectionSvg: any;
  excessDirectionSvg: any;
  movementDirectionSvg: any;
  customSanitizerSvg: any;
  id: any;
  var_icono: any;
  var_color: any;
  customurl: any;
  icon_url: any;
  customsvg: any;
  relenti_svg: any;
  excess_svg: any;
  movement_svg: any;
  movement_onda: any;
}

export interface TypeVehicleUserData{
  var_icono: any;
  var_color: any;
  type_vehicle_id: number;
}

export interface IVehicleIcon {
  id : number,
  var_icono : string,
  var_nombre : string,
  icon_url : string,
  customurl : string,
  customsvg : any,
  customSanitizerSvg : any,
  excess_svg? :any ,
  relenti_svg? : any,
  movement_svg? : any
  relentiDirectionSvg? : any
  excessDirectionSvg? : any
  movementDirectionSvg? : any
  customDirectionSvg? : any
  transmissionStatus? : any
  transmissionIconsByDirection? : any
}

export interface IUserVehicleIcon {
  name_type : string,
  type_vehicle_id : number,
  code_color : string,
  var_icono : string,
  var_color : string,
  var_galon : string,
  var_url_icono : string,
}

export enum ItemIcon  {
  ONDAS = "ondas",
  VEHICLES = "vehicles",
  CURSOR = "cursor",
  NULL = ""
}
export enum TypeIcon {
  AUTO = "auto.svg",
  BUS = "bus.svg",
  CAMIONETA = "camioneta.svg",
  CARGA = "carga.svg",
  MINIBUS_VAN = "minibus_van.svg",
  MOTO = "moto.svg",
  TRACKER = "tracker.svg",
  TRAILER = "trailer.svg",
}
export enum Direction {
  UPLEFT = "UpLeft",
  DOWNLEFT = "DownLeft",
  LEFT = "Left",
  RIGHT = "Right",
  UPRIGHT = "UpRight",
  DOWNRIGHT = "DownRight",
}
export enum TypeColorIcon {
  Default = 'c4c2c1',
  Excess = 'FB472A',
  Relenti = '0396F6',
  Movement = '04DE04',
}